var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { path } from "ramda";
import { SimpleResultProcessing } from "@netdata/react-filter-box";
var castValue = function (value) { return String(value).toLowerCase(); };
/*
== and != equality checks aren't a mistake, it's just a replication
of original library class logic. We can move towards strict equality
if needed.
*/
var FilterBoxProcessing = /** @class */ (function (_super) {
    __extends(FilterBoxProcessing, _super);
    // supports accessor path for nested objects, such as react-table rows
    function FilterBoxProcessing(options, accessor, fieldValueGetters) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.accessor = accessor;
        _this.fieldValueGetters = fieldValueGetters || {};
        _this.tryToGetFieldCategory = _this.tryToGetFieldCategory.bind(_this);
        return _this;
    }
    FilterBoxProcessing.prototype.tryToGetFieldCategory = function (fieldOrLabel) {
        var found = this.options.find(function (f) { return f.columnText == fieldOrLabel; });
        return found ? found.columnField : fieldOrLabel;
    };
    // supports arrays, applying the same filtering logic
    // as original class
    FilterBoxProcessing.prototype.filter = function (row, fieldOrLabel, operator, filterValue) {
        var _a = this, tryToGetFieldCategory = _a.tryToGetFieldCategory, accessor = _a.accessor;
        var category = tryToGetFieldCategory(fieldOrLabel);
        var rowValues = accessor ? path(accessor, row) : row;
        var focusedField = rowValues[category];
        var lowcaseFilterValue = filterValue.toLowerCase();
        var getValue = this.fieldValueGetters[category];
        switch (operator) {
            case "==": {
                if (Array.isArray(focusedField)) {
                    return focusedField.some(function (element) {
                        return getValue ? getValue(element) == filterValue : String(element) == filterValue;
                    });
                }
                return getValue ? getValue(focusedField) == filterValue : focusedField == filterValue;
            }
            case "!=": {
                if (Array.isArray(focusedField)) {
                    return !focusedField.some(function (element) {
                        return getValue ? getValue(element) == filterValue : String(element) == filterValue;
                    });
                }
                return getValue ? getValue(focusedField) != filterValue : focusedField != filterValue;
            }
            case "contains": {
                if (Array.isArray(focusedField)) {
                    return focusedField.some(function (element) {
                        return getValue
                            ? getValue(element).toLowerCase().includes(lowcaseFilterValue)
                            : castValue(element).includes(lowcaseFilterValue);
                    });
                }
                return getValue
                    ? getValue(focusedField).toLowerCase().includes(lowcaseFilterValue)
                    : castValue(focusedField).includes(lowcaseFilterValue);
            }
            case "!contains": {
                if (Array.isArray(focusedField)) {
                    return !focusedField.some(function (element) {
                        return getValue
                            ? getValue(element).toLowerCase().includes(lowcaseFilterValue)
                            : castValue(element).includes(lowcaseFilterValue);
                    });
                }
                return getValue
                    ? !getValue(focusedField).toLowerCase().includes(lowcaseFilterValue)
                    : !castValue(focusedField).includes(lowcaseFilterValue);
            }
            default:
                return false;
        }
    };
    return FilterBoxProcessing;
}(SimpleResultProcessing));
export { FilterBoxProcessing };
